import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface Action {
  actionKey: string
  label: string
}

interface Section {
  sectionKey: string
  label: string
  actions: Action[]
}

interface Page {
  pageKey: string
  label: string
  route: string
  sections: Section[]
}

interface Menu {
  menuKey: string
  label: string
  pages: Page[]
}

interface NavigationData {
  navigation: Menu[]
}

interface NavigationState {
  masterNavigation: NavigationData | null
}

const initialState: NavigationState = {
  masterNavigation: null,
}

const MasterNavigationSlice = createSlice({
  name: 'masterNavigation',
  initialState,
  reducers: {
    // Set the entire master navigation data
    setMasterNavigation: (state, action: PayloadAction<NavigationData>) => {
      state.masterNavigation = action.payload
    },

    // Clear all navigation data
    clearNavigation: (state) => {
      state.masterNavigation = null
    },
  },
})

// Selectors
export const selectMasterNavigation = (state: {
  masterNavigation: NavigationState
}) => state.masterNavigation.masterNavigation

export const { setMasterNavigation, clearNavigation } =
  MasterNavigationSlice.actions

export default MasterNavigationSlice.reducer
